import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { AuthJwtService } from './auth-jwt.service';
import { UserService } from './user.service';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private oktaAuth = inject(OKTA_AUTH, { optional: true });
  private jwtService = inject(AuthJwtService);
  private userService = inject(UserService);
  private router = inject(Router);

  // async getUser(): Promise<{ name: string; roles: string[] }> {
  //   if (environment.useSSO && this.oktaAuth) {
  //     const user = await this.oktaAuth.getUser();
  //     const name = `${user['firstName'] ?? ''} ${user['lastName'] ?? ''}`.trim()
  //       || (user['email'] as string ?? '');
  //     const roles = (user['roles'] as string[]) ?? [];
  //     return { name, roles };
  //   }
  //   return this.jwtService.getUserFromToken();
  // }

  getToken(): string | undefined {
    if (environment.useSSO && this.oktaAuth) {
      return this.oktaAuth.getIdToken();
    }
    return this.jwtService.getToken() ?? undefined;
  }

  async logout(): Promise<void> {
    this.userService.clearUserData();

    if (environment.useSSO && this.oktaAuth) {
      await this.oktaAuth.signOut({ postLogoutRedirectUri: window.location.origin + '/' });
    } else {
      this.jwtService.logout();
      this.router.navigate(['/login']);
    }
  }
}
